import type { SelfServiceItem, SupportChannel } from 'types/help-center';

export const SUPPORT_PREFIX = '/support';
export const supportPath = (path: string) => `${SUPPORT_PREFIX}${path}`;

export const SELF_SERVICE_ITEMS: SelfServiceItem[] = [
  { icon: 'phone-line', label: 'changePhoneNumber', href: '/account/overview?action=changePhone' },
  { icon: 'email-line', label: 'changeEmail', href: '/account/overview?action=changeEmail' },
  { icon: 'password-line', label: 'changePassword', href: '/account/overview?action=changePassword' },
  { icon: 'google-line', label: 'removeGoogleAuth', href: '/account/overview?action=removeGoogle' },
  { icon: 'passkey-line', label: 'managePasskey', href: '/account/manage-authenticator' },
  { icon: 'deposit-line', label: 'cryptoDepositNotArrived', href: supportPath('/Submit-a-Request') },
  { icon: 'anticode-line', label: 'resetSecurityVerification', href: '/reset-security', needAuth: true },
  { icon: 'anticode-line1', label: 'changeAntiPhishingCode', href: '/account/overview?action=changeAntiPhishing' },
  { icon: 'account-line', label: 'closeAccount', href: '/account/close' },
  { icon: 'equipment-line', label: 'checkDevices', href: '/account/devices' },
  { icon: 'history-line', label: 'ticketHistory', href: supportPath('/Submit-a-Request/history') },
];

export const ANNOUNCEMENT_CENTER_LINK = supportPath('/Announcement');

export const SUPPORT_CHANNELS: SupportChannel[] = [
  {
    title: 'submitARequest',
    description: 'submitARequestDesc',
    href: supportPath('/Submit-a-Request'),
    icon: 'edit',
  },
  {
    title: 'channelTermsTitle',
    description: 'channelTermsDesc',
    href: supportPath('/Terms'),
    icon: 'book-fill',
  },
];
